import applogger from '@applogger'

const windowReady = (store) => {
  // Tell the VinCreative Tools Browser Extension that we have a Incipere Site.
  window.postMessage({
    source: 'IncipereApp',
    op: 'ready',
    siteid: store.getters.getSiteId,
    datastore: store.getters.getServiceEndpoint('datastore') + '/graphql',
    location: window.location.origin,
    sitemode: 'incipere',
    logo: `${window.location.origin}/dist/logos/website/logo.svg`
  })
}

export default function({store, app}) {
  if (typeof window !== 'undefined' && typeof chrome !== 'undefined') {
    window.addEventListener('message', (event) => {
      if (event.data.source === 'IncipereExtension') {
        switch (event.data.op) {
        case 'open':
          windowReady(store)
          break

        case 'impersonateUser':
          return store.dispatch('showProgressLoader')
            .then(_ => store.dispatch('user/injectAuthJWT', event.data.auth))
            .then(response => {
              if (store.getters['user/isLoggedIn']) {
                app.vueapp.$eventHub.$emit('loginComplete')
                app.vueapp.$eventHub.$emit('statusMessage', {type: 'success', title: 'Impersonate User - Login Successful!', text: 'Your login attempt succeeded.', showClose: false, timeout: 3500})
                applogger.debug('Impersonate User - Login Successful')

                window.postMessage({
                  source: 'IncipereApp',
                  op: 'impersonatedUser',
                  status: true,
                  account: store.getters['user/userid'],
                  location: window.location.origin
                })
              }
            })
            .catch(err => {
              app.vueapp.$eventHub.$emit('loginFailed')
              app.vueapp.$eventHub.$emit('statusMessage', {type: 'error', title: 'Impersonate User - Login Failed!', text: `Your login attempt failed - ${err.message}.`, showClose: false, timeout: 3500})
              applogger.debug('Impersonate User - Login failed')
              window.postMessage({
                source: 'IncipereApp',
                op: 'impersonatedUser',
                status: true,
                error: err.message
              })
            })
            .then(_ => store.dispatch('hideProgressLoader'))
        }
      }
    })
    setTimeout(() => {
      windowReady(store)
    }, 500)
  }
}
